// removed by extract-text-webpack-plugin
module.exports = {"base":"RewardBox_base--3qOac","label":"RewardBox_label--2cUiM"};


//////////////////
// WEBPACK FOOTER
// ./components/RewardBox/RewardBox.scss
// module id = 2473
// module chunks = 11